<!-- Modo card (por defecto) -->
<div class="filter-card" *ngIf="showCard">
  <div class="filter-header">
    <h5 class="filter-title">Filtros</h5>
    <button *ngIf="showClearButton" pButton type="button" label="Limpiar filtros" icon="pi pi-times" class="p-button-outlined p-button-secondary filter-clear-btn" (click)="clearFilters()"></button>
  </div>
  <ng-container *ngTemplateOutlet="filterGrid"></ng-container>
</div>

<!-- Modo embedded (showCard=false): sin card, solo los inputs -->
<ng-container *ngIf="!showCard">
  <ng-container *ngTemplateOutlet="filterGrid"></ng-container>
  <div class="flex justify-end mt-2" *ngIf="showClearButton">
    <button pButton type="button" label="Limpiar filtros" icon="pi pi-times" class="p-button-outlined p-button-secondary filter-clear-btn" (click)="clearFilters()"></button>
  </div>
</ng-container>

<!-- Grid de inputs compartido -->
<ng-template #filterGrid>
  <div class="grid grid-cols-12 gap-3">
    @for (item of filtros; track $index) {
      @if(item.type == 'dropdown') {
        <ng-template *ngTemplateOutlet="dropdown; context: { $implicit: item }"></ng-template>
      }
      @if(item.type == 'input') {
        <ng-template *ngTemplateOutlet="input; context: { $implicit: item }"></ng-template>
      }
      @if(item.type == 'date') {
        <ng-template *ngTemplateOutlet="date; context: { $implicit: item }"></ng-template>
      }
      @if(item.type == 'multiselect') {
        <ng-template *ngTemplateOutlet="multiselect; context: { $implicit: item }"></ng-template>
      }
    }
  </div>
</ng-template>

<ng-template #dropdown let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <app-dropdown
      [etiqueta]="i.label"
      [id]="i.query"
      [(option)]="i.value"
      [placeholder]="i.placeholder"
      [options]="i.options"
      [propiedad]="i.property"
      [(option)]="i.value"
      [filtrar]="true"
      [limpiar]="!i.disabled"
      [setFirstValue]="false"
      (optionChange)="changeInput(i.query, $event ? $event[i.searchProperty] : '')"
      [readonly]="i.disabled"
    />
  </div>
</ng-template>

<ng-template #input let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <app-input
      [etiqueta]="i.label"
      [(valor)]="i.value"
      [id]="i.query"
      [placeholder]="i.placeholder"
      [(valor)]="i.value"
      (valorChange)="changeInput(i.query, $event)"
      [readonly]="i.disabled"
    />
  </div>
</ng-template>

<ng-template #date let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <app-calendar
      [etiqueta]="i.label"
      [id]="i.query"
      [placeholder]="i.placeholder"
      [(valor)]="i.value"
      [showIcon]="true"
      [showClear]="!i.disabled"
      (valorChange)="changeInput(i.query, $event)"
      [readonly]="i.disabled"
    />
  </div>
</ng-template>

<ng-template #multiselect let-i>
  <div class="lg:col-span-3 md:col-span-6 sm:col-span-12 col-span-12">
    <app-dropdown
      [multiple]="true"
      [etiqueta]="i.label"
      [id]="i.query"
      [placeholder]="i.placeholder"
      [options]="i.options"
      [propiedad]="i.property"
      [(option)]="i.value"
      [setFirstValue]="false"
      [filtrar]="true"
      [limpiar]="!i.disabled"
      (optionChange)="changeInput(i.query, $event ? returnMap($event, i.searchProperty) : '')"
      [readonly]="i.disabled"
    />
  </div>
</ng-template>
